import { render, staticRenderFns } from "./DeviceReport.vue?vue&type=template&id=54816a39&"
import script from "./DeviceReport.vue?vue&type=script&lang=js&"
export * from "./DeviceReport.vue?vue&type=script&lang=js&"
import style0 from "./DeviceReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports